import { Group, Text, Title } from '@mantine/core';
import EyeIcon from '@/icons/eye.svg';
import { Delete } from './Delete';
import { PublishedModel } from '../../interfaces/api';

type HeaderProps = {
  model: PublishedModel;
  withDelete?: boolean;
};

export const Header = ({ model, withDelete = false }: HeaderProps) => {
  return (
    <Group>
      <Title order={6}>{model.name}</Title>
      <Group gap='xs'>
        <EyeIcon style={{ width: 20, height: 20 }} />
        <Text>{model.view_count}</Text>
      </Group>
      {withDelete && <Delete variant='small' id={model.id} assetId={model.model_id} />}
    </Group>
  );
};
